export default {
    "maia_chatbot_open_message_lite": "Hello, I'm {name}, your virtual assistant.",
    "maia_chatbot_open_message_lite_with_account": "Hello, I'm {name}, virtual assistant for {accountName}.",
    "maia_chatbot_alertMessage": "Hello, I'm {name}, your virtual assistant.",
    "maia_chatbot_open_message": "Hello, I'm {name}, your virtual assistant.",
    "maia_chatbot_open_message_with_account": "Hello, I'm {name}, virtual assistant for {accountName}.",
    "maia_chatbot_welcomeMessage": "Hello, I'm {name}, your virtual assistant.",
    "maia_chatbot_follow_message": "Choose an option or type your request.",
    "maia_virtual_assistant": "{name} - Virtual Assistant",
    "maia_chatbot_input_placeholder": "Type your message...",
    "send": "Send",
    "maia_chatbot_skill_see_more": "See more",
    "maia_chatbot_promotion_includes": "Includes:",
    "maia_chatbot_promotion_terms_and_conditions": "Terms and conditions:",
    "maia_chatbot_promotion_see_promotion": "See promotion",
    "maia_chatbot_promotion_min_rate": "Rate from {minRate}",
    "maia_chatbot_book": "Book",
    "maia_chatbot_skill_itinerary_title": "Reservation {name}",
    "maia_chatbot_skill_itinerary_reserved_for": "Reserved for:",
    "maia_chatbot_skill_itinerary_status_CONFIRMED": "Confirmed",
    "maia_chatbot_skill_itinerary_status_PENDING": "Pending",
    "maia_chatbot_skill_itinerary_status_CANCELLED": "Cancelled",
    "maia_chatbot_skill_itinerary_see_full_itinerary": "See full itinerary",
    "maia_chatbot_skill_map_title": "Location",
    "maia_chatbot_skill_map_directions_button": "Get directions",
    "maia_chatbot_skill_itinerary_ota_message": "This reservation was made through an online travel agency ({otaName}). For more details, please check your email or contact {otaName} directly.",
    "maia_chatbot_skill_rating_thanks": "Thank you!",
    "maia_chatbot_skill_rating_error": "Please try again"
};
